<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Confirmation link') }}</h4>
    </div>
    <div class="modal-body">
      <div class="row">   
        <div class="col-md-12">
          <div class="form-group">
  					<input class="form-control" type="text" :value="confirmationLink"> 
          </div>
        </div>
      </div>
      <div class="row" v-if="versions && versions.length">
        <div class="col-xs-12">
          <div class="form-group">
            <select class="form-control" v-model="confirmationLinkVersion">
              <option v-for="version in versions" :value="version">{{ getVersionName(version) }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="email">{{ _('Email') }}</label>
  					<input id="email" class="form-control" type="email" v-model="confirmationLinkEmail"> 
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="subject">{{ _('Message subject') }}</label>
  					<input id="subject" class="form-control" type="subject" v-model="confirmationLinkSubject"> 
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="message">{{ _('Message') }}</label>
            <textarea class="form-control" id="message" rows="5" wrap="virtual" v-model="confirmationLinkMessage"></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-on:click="sendConfirmationLink" :disabled="!canSend"><i class="fa fa-send fa-fw"></i> {{ _('Send email') }}</button>
    </div>
  </div>
</template>

<script>
import errors from '~/lib/errors'
import constants from '~/lib/constants'
import axios from 'axios'

export default {
  mixins: [errors, constants],
  props: ['originalOrder', 'baseDomain', 'shopId', 'locale', 'versions', 'apiKey', 'settings'],
  data () {
    return {
      order: {},
      email: '',
      subject: '',
      message: '',
      defaultSubject: null,
      defaultMessage: null,
      setting: false,
      version: null,
      texts: {
        'fi_FI': {
          'Confirmation link': 'Vahvistuslinkki',
          'Order': 'Tilaus',
          'There is an an open order for you pending payment.': 'Avoin tilaus odottaa vahvistusta.'
        },
        'en_US': {
          'Confirmation link': 'Confirmation link',
          'Order': 'Order',
          'There is an an open order for you pending confirmation.': 'There is an an open order for you pending confirmation.'
        },
        'sv_SE': {
          'Confirmation link': 'Bekräftelselänken',
          'Order': 'Beställning',
          'There is an an open order for you pending payment.': 'Det finns en öppen order för dig i väntan på bekräftelse.'
        },
        'de_DE': {
          'Confirmation link': 'Link zur Bestätigung',
          'Order': 'Bestellung',
          'There is an an open order for you pending payment.': 'Es liegt eine offene Bestellung für Sie vor, die noch bestätigt werden muss.'
        },
        'it_IT': {
          'Confirmation link': 'Link di conferma',
          'Order': 'Ordine',
          'There is an an open order for you pending payment.': "C'è un ordine aperto per te in attesa di conferma."
        },
        'es_ES': {
          'Confirmation link': 'Enlace de confirmación',
          'Order': 'Pida',
          'There is an an open order for you pending payment.': 'Hay un pedido abierto para usted pendiente de confirmación.'
        },
        'fr_FR': {
          'Confirmation link': 'Lien de confirmation',
          'Order': 'Commande',
          'There is an an open order for you pending payment.': 'Il y a une Commande ouverte pour vous en attente de confirmation.'
        },
        'no_NO': {
          'Confirmation link': 'Lenke til bekreftelse',
          'Order': 'Bestilling',
          'There is an an open order for you pending payment.': 'Det er en åpen bestilling for deg i påvente av bekreftelse.'
        },
      }
    }
  },
  computed: {
    shortLocale () {
      return this.locale.split('_')[0]
    },
    canSend () {
      return this.confirmationLink && this.confirmationLinkEmail && this.order && this.order.identifier
    },
    confirmationLink () {
      if (!this.order || !this.order.identifier) {
        return ''
      }
      return this.baseDomain + this.shopId + '/' + this.confirmationLinkVersion + '/confirm/' + this.order.identifier
    },
    confirmationLinkVersion: {
      get () {
        if (!this.version) {
          return this.locale
        }
        return this.version
      },
      set (newValue) {
        this.version = newValue
      }
    },
    confirmationLinkEmail: {
      get () {
        if (this.email) {
          return this.email
        }
        return this.order.email
      },
      set (newValue) {
        this.email = newValue
      }
    },
    confirmationLinkSubject: {
      get () {
        if (this.subject) {
          return this.subject
        }
        if (this.defaultSubject) {
          return this.defaultSubject
        }
        return this.customTranslation('Confirmation link') + ': ' + this.companyName + ', ' + this.customTranslation('Order') + ': #' + this.order.id
      },
      set (newValue) {
        this.subject = newValue
      }
    },
    confirmationLinkMessage: {
      get () {
        if (this.message) {
          return this.message
        }
        if (this.defaultMessage) {
          return this.defaultMessage
        }
        return this.customTranslation('There is an an open order for you pending confirmation.')
      },
      set (newValue) {
        this.message = newValue
      }
    },
    companyName () {
      return this.settings && this.settings.marketingname ? this.settings.marketingname : this.settings.companyname
    }
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    customTranslation(text) {
      if (!this.texts[this.confirmationLinkVersion] || !this.texts[this.confirmationLinkVersion][text]) {
        return this._(text)
      }
      return this.texts[this.confirmationLinkVersion][text]
    },
    async sendConfirmationLink() {
      try {
        let response
        const data = {
          identifier: this.order.identifier,
          email: this.confirmationLinkEmail,
          subject: this.confirmationLinkSubject,
          message: this.confirmationLinkMessage,
          version: this.confirmationLinkVersion,
          showConfirm: true
        }
        response = await axios.post(this.baseDomain + this.shopId + '/' + this.confirmationLinkVersion + '/confirm/' + data.identifier + '.json?action=send&version=' + this.confirmationLinkVersion + '&apikey=' + this.apiKey, data)
        this.showNotification(this._('Confirmation link sent!'))
        this.$emit('confirmationLinkSent')
      } catch(e) {
        this.showError(e)
        return
      }
      this.hideModal()
    },
    getVersionName (version) {
      if (this.allVersions) {
        const v = this.allVersions.find(v => v.identifier === version)
        if (v) {
          return v.name
        }
      }
      return version
    },
    async loadMessage () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/messages/confirmationLink.json?apikey' + this.apiKey + '&version=' + this.version)
      } catch(e) {
        return
      }
      if (response && response.data) {
        if (response.data.text) {
          this.defaultMessage = response.data.text
        } else {
          this.defaultMessage = null
        }
        if (response.data.subject) {
          this.defaultSubject = response.data.subject
        } else {
          this.defaultSubject = null
        }
      }
    }
  },
  watch: {
    version () {
      if (!this.message) {
        this.loadMessage()
      }
    }
  },
  created() {
    if (this.originalOrder) {
      this.order = Object.assign({}, this.originalOrder)
      if (!this.order.version || this.order.version === 'fi_FI') {
        this.confirmationLinkVersion = 'fi_FI'
      } else if (this.order.version === 'ru_RU') {
        this.confirmationLinkVersion = 'en_US'
      } else {
        this.confirmationLinkVersion = this.order.version
      }
    }
  }
}
</script>